module.exports = __webpack_public_path__ + "img/ic_delete.38d69fb3.svg";